//refresh token logic

//Safe-guard so multiple 401s share one refresh
let refreshPromise = null;

export function getAccess() {
  return sessionStorage.getItem("access");
}

export function getRefresh() {
  return sessionStorage.getItem("refresh");
}

function setAccess(t) {
  sessionStorage.setItem("access", t);
}

export function setRefresh(t) {
  sessionStorage.setItem("refresh", t);
}

export function clearTokens() {
  sessionStorage.removeItem("access");
  sessionStorage.removeItem("refresh");
}

export async function refreshAccessToken() {
  if (refreshPromise) {
    return refreshPromise; // reuse inflight promise
  }

  const refresh = getRefresh(); //refresh token stored locally to the user

  refreshPromise = await fetch(process.env.REACT_APP_BACKEND_URL + '/api/token/refresh/', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ refresh: refresh })
  })
    .then(async (res) => {
      if (!res.ok) {
        throw new Error("Refresh failed!");
      }
      const data = await res.json();
      if (!data.access) {
        throw new Error("No access token");
      }
      setAccess(data.access);
      return data.access;
    })
    .catch((err) => {
      console.warn("Token refresh failed: ", err);
      clearTokens();
      return null;
    })
    .finally(() => {
      refreshPromise = null;
    })

  return refreshPromise
}

// not using this function, prefer to use axios
export async function fetchWithAuth(url, options = {}) {
  let accessToken = getAccess();
  const headers = new Headers(options.headers || {});

  if (accessToken) {
    headers.set("Authorization", `Bearer ${accessToken}`);
  }

  if (!headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }

  if (!headers.has("Accept")) {
    headers.set("Accept", "application/json");
  }


  let response = await fetch(url, {
    ...options,
    headers
  })

  if (response.status === 401) {
    const newAccessToken = await refreshAccessToken();

    if (!newAccessToken) return response //refresh failed

    const retryHeaders = new Headers(options.headers || {});
    retryHeaders.set("Authorization", `Bearer ${newAccessToken}`);

    if (!headers.has("Content-Type")) {
      retryHeaders.set("Content-Type", "application/json");
    }

    if (!headers.has("Accept")) {
      retryHeaders.set("Accept", "application/json");
    }

    response = await fetch(url, { ...options, headers: retryHeaders });
  }
  return response
}

// utils/authUtils.js

export async function isValidJWTFormat(token) {
  if (!token || typeof token !== 'string') {
    return false;
  }

  // JWT has 3 parts separated by dots: header.payload.signature
  const parts = token.split('.');
  if (parts.length !== 3) {
    return false;
  }

  // Check each part is base64 encoded (basic check)
  try {
    parts.forEach(part => {
      if (part.length === 0) {
        throw new Error('Empty part');
      }
      // Try to decode - will throw if invalid base64
      atob(part.replace(/-/g, '+').replace(/_/g, '/'));
    });
    return true;
  } catch {
    return false;
  }
}